import {PolymerElement, html} from '@polymer/polymer/polymer-element.js';
import '@polymer/iron-image/iron-image.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@cbar/localizemixin/LocalizeMixin.js';
import '@polymer/paper-card/paper-card.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/paper-button/paper-button.js';
import '@material/web/dialog/dialog.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-icon/iron-icon.js';
import {format} from '@cbar/cbar-address-format';
import '@polymer/iron-pages/iron-pages.js';

/**
 * `cbar-entity-summary`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */

class CbarEntitySummary extends Cbar.LocalizeMixin(PolymerElement) {
  static get template() {
    return html`
        <style include="cbar-shared-styles">
            :host {
                width: 100%;
                --cbar-member-list-width: 50%;
                font-family: Roboto, noto, sans-serif;
                background: var(--cbar-sys-color-surface, white);
            }

            .heading-image {
                width: 100%;
                height: calc(338 / 1235 * 100%);

                position: relative;
            }

            #cover-image {
                height: 0;
                padding-top: calc(338 / 1235 * 100%);
                width: 100%;
                position: absolute;
            }

            #profile-image {
                min-height: 80px;
                min-width: 80px;
                height: 80px;
                width: 80px;
                border-radius: 50%;
                margin: 8px 8px 8px 8px;
            }

            .main-card {
                width: 100%;
            }

            #static-header-icon {
                position: absolute;
                top: 0;
                left: 0px;
                color: white;
            }

            .flexbox-wrapper {
                padding:8px;
                background-color: var(--cbar-sys-color-surface, var(--cbar-dark-primary-color, #003F83));
            }

            .flexbox {
                display: flex;
                padding-right: 8px;
                justify-content: space-between;
                align-items: center;
                margin: 0 auto;
            }

            .entity-id-div {
                display: flex;
                align-items: center;
                padding-top: 8px;
                padding-bottom: 8px;
            }

            #location-details {
                width: calc(25% + 32px);
                padding: 0 16px;
            }

            #location-details iron-icon{
                flex-shrink: 0;
                margin-right: 5px;
            }

            .time-icon, .location-icon{
                flex-shrink: 0;
                margin-right: 5px;
            }

            #join-button {
                height: 30px;
                align-self: center;
                color: var(--cbar-sys-color-on-surface, var(--cbar-dark-primary-color, #003F83));
                background-color: var(--cbar-sys-color-surface, white);
            }

            #leave-button {
                height: 30px;
                align-self: center;
                color: var(--cbar-sys-color-on-surface, var(--cbar-dark-primary-color, #003F83));
                background-color: var(--cbar-sys-color-surface, white);
            }

            paper-menu-button {
                color: var(--cbar-sys-color-on-surface, white);
            }

            [hidden] {
                display: none
            }

            .member-count-button {
                float: right;
                font-size: 0.8em;
            }

            #entity-name {
                color: var(--cbar-sys-color-on-surface, white);
                margin: 0;
            }

            .buttons-div {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .header-div {
                position: relative;
            }

            .name-div {
                display: flex;
                flex-direction: column;
                align-items: end;
                margin-left: 8px;
            }

            .fit-bottom {
                bottom: 0;
                top: unset !important;
            }

            .icon-div {
                display: flex;
                margin-bottom: 16px;
            }

            #member-list-display {
                color: var(--cbar-sys-color-on-surface, white);
                text-align: center;
                margin-top: 5px;
            }

            #toast paper-button {
                margin: 0;
                height: 100%;
            }
            
            .flexbox-top{
                align-items: start;
            }

            .time-div-centered{
                display: flex;
                align-items: center;
            }

            .icon-label {
                flex-wrap: wrap;
            }

            #toast {
                padding: 0 24px;
                left: 0;
                right: 0;
                display: flex;
                position: fixed;
                /* make sure this sits under mwc-dialogs and the sidenav*/
                z-index: 0 !important;
                max-width: 100% !important;
                align-items: center;
            }

            :host([editing]) .profile-overlay-div, :host([editing]) .banner-overlay-div {
                position: absolute;
                z-index: 0;
                background: grey;
                opacity: 0.8;

                display: flex;
                justify-content: center;
                align-items: center;

                cursor: pointer;
            }

            :host([editing]) .banner-overlay-div {
                height: calc(100% + 4px);
                width: 100%;

            }

            :host([editing]) .profile-overlay-div {
                margin: 8px;
                border-radius: 50%;
                height: 80px;
                width: 80px;
            }

            :host([multiline-address]) #location-div{
                white-space: pre;
            }

            .background-color-animation {
                -webkit-transition: background-color 100ms linear;
                -ms-transition: background-color 100ms linear;
                transition: background-color 100ms linear;
            }

            .image-overlay-button {
                color: black;
            }

            :host([editing]) .profile-overlay-div:hover, :host([editing]) .banner-overlay-div:hover {
                background: black;
            }

            :host([editing]) .profile-overlay-div:hover .image-overlay-button, :host([editing]) .banner-overlay-div:hover .image-overlay-button {
                color: white;
            }

            @media (max-width: 600px) {
                .heading-image, #cover-image {
                    height: calc(600 / 1235 * 100%);
                }

                .vertical-on-small{
                    flex-direction: column;
                }

                .vertical-on-small > *{
                    padding-bottom: 8px;
                }

                #location-details {
                    padding: 0;
                    width: 100%;
                }
            }

        </style>

        <div class="header-div">
            <div class="heading-image" hidden$="[[hideBanner]]">
                <div class="banner-overlay-div background-color-animation" on-tap="__handleBannerEdit"
                    hidden$="[[!editing]]">
                    <iron-icon icon="editor:mode-edit" class="image-overlay-button"></iron-icon>
                </div>
                <iron-image id="cover-image" sizing="cover" src="[[banner]]"></iron-image>
            </div>
            <div class="flexbox-wrapper">
                <div class="flexbox">
                    <div class="entity-id-div">
                        <template is="dom-if" if="[[logo]]">
                            <div>
                                <div class="profile-overlay-div background-color-animation" on-tap="__handleProfileEdit"
                                    hidden$="[[!__editingProfileImage]]">
                                    <iron-icon icon="editor:mode-edit" class="image-overlay-button"></iron-icon>
                                </div>
                                <iron-image id="profile-image" sizing="cover" src="[[logo]]"></iron-image
                            </div>
                        </template>
                        <div class="name-div">
                            <h5 id="entity-name">[[title]]</h5>
                            <div id="member-list-display" hidden$="[[hideEntityCountDisplay]]">[[_entityMemberCount]]
                                [[localize(_entityMemberCountTerm)]]
                            </div>
                        </div>
                    </div>
                    <div style="padding: 16px;">
                      <paper-menu-button horizontal-align="right" vertical-offset="50" id="menuContainer" hidden
                          style="padding: 0; height: 24px; width: 24px;">
                          <paper-icon-button icon="more-vert" slot="dropdown-trigger"></paper-icon-button>
                          <slot name="menu-items" on-slotchange="_menuSlotChanged" slot="dropdown-content"></slot>
                      </paper-menu-button>
                    </div>
                    <template is="dom-if" if="[[!noJoinButton]]">
                        <div class="buttons-div">
                            <template is="dom-if" if="[[!disableJoinButton]]">
                                <paper-button id="join-button" hidden\$="[[joined]]" on-tap="_joinGroup"
                                    style="white-space: nowrap">[[localize(joinText)]]
                                </paper-button>
                                <paper-button id="leave-button" hidden\$="[[!joined]]" on-tap="_leaveGroup"
                                    style="white-space: nowrap">[[localize(joinedText)]]
                                </paper-button>
                            </template>
                            <paper-button class="member-count-button" on-tap="_toggleMemberList"
                                hidden$="[[!memberListButton]]" style="white-space: nowrap">[[_entityMemberCount]]
                                [[localize(_entityMemberCountTerm)]]
                            </paper-button>
                        </div>
                    </template>
                </div>
                <div class="flexbox flexbox-top vertical-on-small" style="padding: 8px">
                    <div>
                        <div class="description-div"></div>
                        <template is="dom-if" if="[[__displayLeftDetails]]">
                            <div hidden$="[[!time]]" class="icon-div body-text-2 time-div-centered" style="margin-top:24px">
                                <iron-icon icon="icons:date-range" class="time-icon"></iron-icon>
                                <span class="icon-label" id="time-div"></span></div>
                            <div hidden$="[[!location]]" class="icon-div body-text-2">
                                <iron-icon icon="communication:location-on" class="location-icon"></iron-icon>
                                <span class="icon-label" id="location-div"></span></div>
                        </template>
                    </div>
                    <div id="location-details">
                        <template is="dom-if" if="[[__displayRightDetails]]">
                            <div hidden$="[[!time]]" class="icon-div body-text-2">
                                <iron-icon icon="icons:date-range" class="time-icon"></iron-icon>
                                <span class="icon-label" id="time-div"></span></div>
                            <div hidden$="[[!location]]" class="icon-div body-text-2">
                                <iron-icon icon="communication:location-on" class="location-icon"></iron-icon>
                                <span class="icon-label" id="location-div"></span></div>
                        </template>
                        <slot name="extra-details"></slot>
                    </div>
                </div>
            </div>
        </div>
        <!--Partials are sections that the user can view, however are not accessable via url.-->
        <iron-pages selected="[[_selectedSection]]" attr-for-selected="value">
            <slot name="partials-slot"></slot>
        </iron-pages>

        <md-dialog open="{{_openDialog}}" with-backdrop="" id="confirmationDialog" on-close="__closeHandler">
            <h6 style="text-align: center;" slot="headline">[[localize('Are you sure?')]]</h6>
            <div slot="content">Clicking "yes" will remove you from this group.</div>
            <div class="buttons" slot="actions">
                <paper-button class="flat-button" on-tap="_cancelDelete">[[localize('No')]]</paper-button>
                <paper-button class="flat-button" on-tap="_confirmDelete">[[localize('Yes')]]</paper-button>
            </div>
        </md-dialog>

        <md-dialog id="member-list-dialog" with-backdrop="">
            <communitybuildar-people people="[[entityMembers]]" slot="content"></communitybuildar-people>
        </md-dialog>

        <template is="dom-if" if="[[withToast]]">
          <div id="toast" class="fit-bottom">
              <paper-button on-tap="_fireRouteBack">
                  <iron-icon icon="icons:chevron-left"></iron-icon>
                  [[localize('Back')]]
              </paper-button>
          </div>
        </template>
    `;
  }

  static get is() {
    return 'cbar-entity-summary';
  }

  static get properties() {
    return {
      /**
       * Image that displays at the top of the view
       */
      banner: {
        type: String,
      },
      logo: String,
      /**
       * Name of the entity that we are attempting to display here
       */
      title: String,
      description: {
        type: String,
        value: false,
        observer: "__handleHTMLDescription"
      },
      /**
       * Array of (if existing) members of the entity
       */
      entityMembers: {
        type: Array,
        value: []
      },
      entityMemberCount:{
        type: Number,
        value: 0,
        observer: "_calculateEntityMemberCount"
      },
      _entityMemberCount: Number,
      _entityMemberCountTerm: String,
      memberCountTerm : {
        type: String,
        value: false
      },
      joined: {
        type: Boolean,
        value: false
      },
      _openDialog: {
        type: Boolean,
        value: false
      },
      selectedTab: {
        type: String,
        observer: "_changeSection"
      },
      noBackIcon: {
        type: Boolean,
        value: false
      },
      memberListButton: {
        type: Boolean,
        value: false
      },
      disableJoinButton : {
        type: Boolean,
        value: false
      },
      joinedText: {
        type: String,
        value: "Leave"
      },
      joinText: {
        type: String,
        value: "Join"
      },
      hideEntityCountDisplay : {
        type: Boolean,
        value: false
      },
      editing : {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      hideBanner: {
        type: Boolean,
        value: false
      },
      disableProfileEdit: {
        type: Boolean,
        value: false
      },
      noJoinButton: {
        type: Boolean,
        value: false
      },
      time: {
        type: String,
        value: false,
        observer: "__injectTime"
      },
      location: {
        type: Object,
        value: false,
      },
      detailsPosition: {
        type: String,
        value: "right"
      },
      withToast: {
        type: Boolean,
        value: false
      },
      multilineAddress : {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      }
    };
  }

  static get observers() {
    return [
      "_calculateEntityMemberCount(entityMembers.length)",
      "recalculateHeaderHeight(banner, logo)",
      "calculateProfileEditable(disableProfileEdit, editing)",
      "__handleDetailsPosition(detailsPosition)",
      "formatLocation(location, multilineAddress)"
    ]
  }

  ready(){
    super.ready();

    requestAnimationFrame(() => {
      this.fixHeaderDiv();
    })
  }

  get titleDiv(){
    if(!this.__titleDiv){
      this.__titleDiv = this.root.querySelector('.name-div')
    }
    return this.__titleDiv;
  }

  /**
   * Sets the selected section in the iron pages based on the url sent in from the external page
   */
  _changeSection() {
    this._selectedSection = this.selectedTab
  }

  /**
   * Function that picks up the amount of users inside the array and then sets the count term depending if their is only one or other
   */
  _calculateEntityMemberCount(count) {

    this._entityMemberCount = count;
    this._entityMemberCountTerm = this.memberCountTerm ? this.memberCountTerm : this._entityMemberCount === 1 ? "Member" : "Members";
  }

  /**
   * open/close the member list dialog.
   */
  _toggleMemberList() {
    let memberListElement = this.root.querySelector('#member-list-dialog');
    memberListElement.open ? memberListElement.close() : memberListElement.show();
  }

  calculateProfileEditable(){
    this.__editingProfileImage = this.editing && !this.disableProfileEdit;
  }

  /**
   * Fires a join event that is handled externally
   */
  _joinGroup() {
    let joinEvent = new CustomEvent('join-button-clicked', {
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(joinEvent);
  }

  /**
   * opens a dialog that prompts the user to make sure that they want to delete the entity from their list
   */
  _leaveGroup() {
    this._openDialog = true;
  }

  /**
   * if "no" we keep the entity and close the dialog
   */
  _cancelDelete() {
    this._openDialog = false;
  }

  /**
   * if yes we create a new event for leaving thats is handled externally.
   */
  _confirmDelete() {
    let leaveEvent = new CustomEvent('leave-button-clicked', {
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(leaveEvent);
    this._openDialog = false;
  }

  /**
   * Function that fires a listener that the entities page or any page can use to view the previous page, handled externally.
   * @private
   */
  _fireRouteBack() {
    let routeEvent = new CustomEvent('back-button-clicked', {
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(routeEvent);
  }

  fixHeaderDiv(){
    let headerDiv = this.root.querySelector('.heading-image');

    if(!headerDiv){
      return;
    }

    window.addEventListener('resize', this.recalculateHeight.bind(this));

    this.initialCheck = true;
    this.recalculateHeight();
  }

  recalculateHeight(){
    // fixes initial render problems
    let headerDiv = this.root.querySelector('.heading-image');
    let coverImage = this.root.querySelector('#cover-image');

    let smallOffset = window.innerWidth <= 600 && this.initialCheck ? "40" : "-4";

    headerDiv.style.height = `calc(${coverImage.offsetHeight}px + ${smallOffset}px)`;

    this.initialCheck = false;
  }

  recalculateHeaderHeight(){
    requestAnimationFrame(() => {
      this.initialCheck = true;
      this.recalculateHeight();
    });

    // attempt again
    setTimeout(() => {
      this.fixHeaderDiv();
    }, 2000)
  }

  __handleProfileEdit(){
    this.dispatchEvent(new CustomEvent('profile-edit', {
      bubbles: true,
      composed: true,
      detail: {
        initialImage: this.logo
      }
    }));
  }

  __handleBannerEdit(){
    this.dispatchEvent(new CustomEvent('banner-edit', {
      bubbles: true,
      composed: true,
      detail: {
        initialImage: this.banner
      }
    }));
  }

  _menuSlotChanged(e) {
    this.$.menuContainer.hidden = !e.target.assignedNodes({flatten: true}).length;
    // dont display bo
    this.noJoinButton = !this.$.menuContainer.hidden
  }

  __handleHTMLDescription(description){
    if(!description){
      return;
    }

    let descriptionDiv = this.root.querySelector('.description-div');

    descriptionDiv.innerHTML = description;
  }

  __injectTime(time) {
    requestAnimationFrame(() => {
      if (!time) {
        return
      }
      this.root.querySelector('#time-div').innerHTML = time;
    });
  }

  formatLocation(location, multi) {
      if (!location || Object.keys(location).length === 0) {
        return;
      }
      
      if(typeof location === "string"){
          this.location = JSON.parse(location);
          return;
      }

      requestAnimationFrame(() => {
        this.root.querySelector('#location-div').innerHTML = format(location, multi);
      });
  }

  __handleDetailsPosition(position){
    this.__displayRightDetails = position === "right";
    this.__displayLeftDetails = !this.__displayRightDetails;
  }

  __closeHandler(){
    this._openDialog = false;
  }
}

window.customElements.define(CbarEntitySummary.is, CbarEntitySummary);
